const TAB_KEY = 'additionalServices'
export default {
  data () {
    return {
      additionalServicesKey: TAB_KEY
    }
  },

  computed: {
    additionalServicesCreateConfig () {
      return {
        title: this.$t('base.additional_services'),
        key: TAB_KEY,
        visible: !!this.permissions?.isMaster,
        validationErrors: this.validationErrors,
        tabContent: [
          {
            component: this.columnsContentComponent,
            title: this.$t('base.additional_services'),
            showButtons: false,
            rows: [
              {
                type: 'fields',
                columnsCount: 2,
                fields: [
                  {
                    key: 'services.HERE.attributes.maps',
                    label: this.$t('base/company.here_maps'),
                    type: 'base-switch',
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'services.HERE.attributes.speed_limits',
                    label: this.$t('base/company.here_speed_limits'),
                    type: 'base-switch',
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'services.HERE.attributes.georeverse',
                    label: this.$t('base/company.georeverse'),
                    type: 'base-switch',
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'services.DIGITAL_OUTPUTS.attributes.digital_outputs',
                    label: this.$t('base/company.digital_outputs'),
                    type: 'base-switch',
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'services.SMS_ALERTS.attributes.sms_alerts',
                    label: this.$t('base/company.sms_alerts'),
                    type: 'base-switch',
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'services.LONG_STOP.attributes.long_stop',
                    label: this.$t('base/company.long_stop'),
                    type: 'base-switch',
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'services.TRIP_GEOLOCATION.attributes.trip_geolocation',
                    label: this.$t('base/company.trip_geolocation'),
                    type: 'base-switch',
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'services.HIGH_PRIORITY_IGNORE_RECORDS.attributes.high_priority_ignore_records',
                    label: this.$t('base/company.high_priority_ignore_records'),
                    type: 'base-switch',
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'services.VEHICLE_CREW_REGISTRATION.attributes.vehicle_crew_registration',
                    label: this.$t('base/company.vehicle_crew_registration'),
                    type: 'base-switch',
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'services.COORDINATES_MINIMUM_DISTANCE.attributes.coordinates_minimum_distance',
                    label: this.$t('base/company.coordinates_minimum_distance'),
                    field_type: 'number',
                    creatable: true,
                    editable: true,
                    visible: true
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}
